/* product-model.js — AR/XR & model-viewer-ui hardened init */

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
      this.modelViewerUI = null;
    }

    loadContent() {
      // Зарежда <template> съдържанието (DeferredMedia)
      super.loadContent();

      // Зареди UI за model-viewer
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      const mv = this.querySelector('model-viewer');
      if (!mv) return;

      // Подсигури ключовите AR/XR атрибути (в случай че липсват)
      mv.toggleAttribute('data-shopify-xr', true);
      mv.toggleAttribute('data-shopify-model-viewer-ui', true);
      mv.toggleAttribute('ar', true);
      if (!mv.hasAttribute('ar-modes')) {
        mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
      }
      // Не пипаме ios-src/src тук — те трябва да идват от Liquid (GLB + USDZ)

      // Инициализирай UI само веднъж
      if (!this.modelViewerUI) {
        try {
          this.modelViewerUI = new Shopify.ModelViewerUI(mv);
        } catch (e) {
          // Ако UI още не е наличен, пробвай леко отложена инициализация
          setTimeout(() => {
            try { this.modelViewerUI = new Shopify.ModelViewerUI(mv); } catch (_) {}
          }, 0);
        }
      }
    }
  });
}

window.ProductModel = {
  /** Зареди Shopify XR и закачи AR бутона към елементите */
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  /** Регистрирай моделите и активирай XR елементите */
  setupShopifyXR(errors) {
    if (errors) return;

    // Изчакай глобалния обект при ленив сценарий
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    // Нахрани XR с JSON-ите за моделите
    const jsonNodes = document.querySelectorAll('[id^="ProductJSON-"]');
    jsonNodes.forEach((node) => {
      const txt = node.textContent && node.textContent.trim();
      if (!txt) return;
      try {
        const data = JSON.parse(txt);
        window.ShopifyXR.addModels(data);
      } catch (_) {
        // игнорирай счупен JSON
      } finally {
        // махаме нода, както е по оригинала
        node.remove();
      }
    });

    // Рекачване на AR/XR бутоните
    window.ShopifyXR.setupXRElements();
  },

  /** Инициализирай новоинжектирани секции/гледки */
  reinitOnDynamicChange() {
    // 1) Увери се, че всички product-model елементи имат UI
    document.querySelectorAll('product-model').forEach((pm) => {
      if (!pm) return;
      if (!pm.modelViewerUI) {
        const mv = pm.querySelector('model-viewer');
        if (mv) {
          try {
            pm.modelViewerUI = new Shopify.ModelViewerUI(mv);
          } catch (_) {}
        }
      }
      // Подсигури AR атрибутите, в случай че секцията е инжектирана без тях
      const mv = pm.querySelector('model-viewer');
      if (mv) {
        mv.toggleAttribute('data-shopify-xr', true);
        mv.toggleAttribute('data-shopify-model-viewer-ui', true);
        mv.toggleAttribute('ar', true);
        if (!mv.hasAttribute('ar-modes')) {
          mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
        }
      }
    });

    // 2) XR hook-ове след като моделите са в DOM
    this.loadShopifyXR();
  },
};

/* --------- Глобални слушатели за стабилност --------- */

// Първоначален boot
window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

// Online store editor/динамични секции
document.addEventListener('shopify:section:load', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});
document.addEventListener('shopify:section:unload', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});
document.addEventListener('shopify:section:select', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});
document.addEventListener('shopify:section:deselect', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});

// Смяна на вариант (ако темата вдига такова събитие)
document.addEventListener('variant:change', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});

// Понякога SPA навигации вдигат "page:load"
document.addEventListener('page:load', () => {
  if (window.ProductModel) window.ProductModel.reinitOnDynamicChange();
});
